
import './SettingsSection.scss';
import classNames from 'classnames';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import React, { PropsWithChildren } from 'react';

export interface SettingsSectionProps {
	className?: string;
	subheading?: string;
	title: React.ReactNode;
}

export const SettingsSection: React.FC<PropsWithChildren<SettingsSectionProps>> = ({
	children,
	className,
	subheading,
	title
}) => {
	const displayTitle = typeof title === 'string' ? <SonarText className='h2'>{ title }</SonarText> : title;

	return (
		<div className={ classNames('settings-section', className) }>
			<div className='title'>{ displayTitle }</div>
			<When condition={ subheading }>
				<SonarText className='subheading'>{ subheading }</SonarText>
			</When>
			{ children }
		</div>
	);
};

